import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Section1 from './Section1';
import Footer from './Footer';

// GA and Pixel
// import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';

function App() {

  // Initialize Google Analytics and Facebook Pixel
  useEffect(() => {
    // ตั้งค่า GA ด้วย Measurement ID ของคุณ
    // ReactGA.initialize('G-XXXXXXXXXX');  // ใส่ GA Measurement ID ของคุณ
    // ReactGA.send('pageview');  // ส่ง pageview ให้ GA ติดตามการเปิดหน้าเว็บ

    // ตั้งค่า Facebook Pixel ด้วย Pixel ID ของคุณ
    ReactPixel.init('1437860293836911'); // ใส่ Facebook Pixel ID ของคุณ
    ReactPixel.pageView();  // ส่ง pageview ให้ Facebook Pixel ติดตามการเปิดหน้าเว็บ
  }, []);

  // ฟังก์ชันติดตามการกดปุ่ม Add Line โดยแยก source ระหว่าง Section1 และ Footer
  const handleAddLineClick = (source) => {
    console.log("source" , source);
    
    // ส่ง event ให้ Google Analytics
    // ReactGA.event({
    //   category: 'Button',
    //   action: 'Add Line Button Click',
    //   label: `Add Line - ${source}`,
    // });

    // ส่ง event ให้ Facebook Pixel
    ReactPixel.track('AddLineButtonClick', {
      buttonName: `Add Line - ${source}`,
      timestamp: new Date().toISOString(),
    });

    // เปิดลิงก์ Line
    window.open("https://lin.ee/djFqNgN", "_blank");
  };

  return (
    <Router>
      <Routes>
        {/* ตั้งค่า path เป็น /linepromo */}
        <Route path="/linepromo" element={
          <div>
            <Section1 onAddLineClick={() => handleAddLineClick('Upper')} />
            <Footer onAddLineClick={() => handleAddLineClick('Bottom')} />
          </div>
        } />
        {/* กำหนดให้ path หลัก (/) redirect ไปที่ /linepromo */}
        <Route path="/" element={<Navigate to="/linepromo" />} />
      </Routes>
    </Router>
  );
}

export default App;
